import { render } from "./DropdownDefault.vue?vue&type=template&id=bf4e5a04&scoped=true"
import script from "./DropdownDefault.vue?vue&type=script&lang=js"
export * from "./DropdownDefault.vue?vue&type=script&lang=js"

import "./DropdownDefault.vue?vue&type=style&index=0&id=bf4e5a04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4e5a04"]])

export default __exports__